import {createApp} from 'vue'
import Store from 'store'
import ProductTable from './ProductTable'

const component = createApp(ProductTable).use(Store)

const el = '.nlx-component--product-table'
const DOM = document.querySelector(el)

if(DOM){
    component.mount(el)
}
